import { useState, useEffect } from "react";
import { GuidEnum } from "../../../models/enums/GuidEnum";
import RelatedProfilesGridModel from "../../../models/company/relatedAndShortlistedProfiles/response/RelatedProfilesGridModel";
import RelatedProfilesRequestModel from "../../../models/company/relatedAndShortlistedProfiles/request/RelatedProfilesRequestModel";
import companyClasses from "../../../landing-pages/company/company.module.css";
import TablePagination from "@mui/material/TablePagination";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import toasterUtils from "../../../utils/toaster-utils";

interface RelatedProfilesGridProps {
    relatedProfilesList: RelatedProfilesGridModel[];
    requirementId: string;
    totalSize: number;
    currentPage: number;
    pagesize: number;
    sortColumn: string;
    sortDirection: "asc" | "desc";
    pageSizesList: number[];
    onShortlistProfile: (row: RelatedProfilesRequestModel) => void;
    onRatingDetails: (row: RelatedProfilesRequestModel, hasAccess: boolean) => void;
    onPageChangeAction: (newPage: number) => void;
    onPageSizeChangeAction: (newPageSize: number) => void;
};

const RelatedProfilesGridComponent = (props: RelatedProfilesGridProps) => {

    const shortlistCandidate = (objProfile: RelatedProfilesGridModel) => {
        let updateModel: RelatedProfilesRequestModel = {
            requirementId: objProfile.requirementId,
            candidateId: objProfile.candidateId,
            interviewId: objProfile.interviewId,
            userId: GuidEnum.Empty
        }
        props.onShortlistProfile(updateModel);
    };

    const viewRating = (objProfile: RelatedProfilesGridModel) => {
        if (!objProfile.isRequestSent) {
            let updateModel: RelatedProfilesRequestModel = {
                requirementId: objProfile.requirementId,
                candidateId: objProfile.candidateId,
                interviewId: objProfile.interviewId,
                userId: GuidEnum.Empty
            }
            props.onRatingDetails(updateModel, objProfile.restrictEmployerToViewProfile);
        } else {
            toasterUtils.showWarning("Request Already Sent, please wait untill candidates approves your request to check rating.");
        }
    };

    const handleChangePage = (event: any, newPage: number) => {
        props.onPageChangeAction(newPage);
    };

    const handleChangeRowsPerPage = (event: any) => {
        props.onPageSizeChangeAction(parseInt(event.target.value, 10));
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Candidate Name</TableCell>
                                <TableCell>Experience</TableCell>
                                <TableCell>Notice Period</TableCell>
                                <TableCell>Interview Date</TableCell>
                                <TableCell>Rating</TableCell>
                                <TableCell>Request Sent</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {props.relatedProfilesList.map((profile: RelatedProfilesGridModel, index) => (
                                <TableRow key={index}>
                                    <TableCell>{profile.candidateName}</TableCell>
                                    <TableCell>{profile.experience}</TableCell>
                                    <TableCell>{profile.noticePeriod}</TableCell>
                                    <TableCell>{profile.interviewDate}</TableCell>
                                    <TableCell>{profile.totalRating}</TableCell>
                                    <TableCell>{profile.isRequestSent ? "Sent" : "Not Sent"}</TableCell>
                                    <TableCell>
                                        <a onClick={() => viewRating(profile)} className="grid-icon blue mx-2" title="view rating">
                                            <i className="fas fa-star"></i>
                                        </a>
                                        <a onClick={() => shortlistCandidate(profile)} className="grid-icon orange" title="shortlist">
                                            <i className="fas fa-check" style={{ fontSize: '1.2em' }}></i>
                                        </a>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={props.pageSizesList}
                    component="div"
                    count={props.totalSize}
                    rowsPerPage={props.pagesize}
                    page={props.currentPage - 1}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage} />
            </div>
        </div>
    );
};
export default RelatedProfilesGridComponent;